"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigation_en = void 0;
exports.navigation_en = {
    listTitle: 'Choose a module',
};
